/** The closed list a passage's `text_search_config` CHECK names (migration 0143). */
export const TEXT_SEARCH_CONFIG = [
    "simple",
    "wetalk_greek",
    "english",
    "spanish",
    "french",
    "german",
    "italian",
    "portuguese",
    "dutch",
    "swedish",
    "danish",
    "finnish",
    "hungarian",
    "romanian",
    "lithuanian",
    "turkish",
    "russian",
    "arabic",
];
export function isTextSearchConfig(value) {
    return TEXT_SEARCH_CONFIG.includes(value);
}
/** By primary language subtag. Every language not listed is `simple` (he cs bg hr sk sl et lv uk, …). */
const STEMMED_BY_PRIMARY_SUBTAG = Object.freeze({
    el: "wetalk_greek",
    en: "english",
    es: "spanish",
    fr: "french",
    de: "german",
    it: "italian",
    pt: "portuguese",
    nl: "dutch",
    sv: "swedish",
    da: "danish",
    fi: "finnish",
    hu: "hungarian",
    ro: "romanian",
    lt: "lithuanian",
    tr: "turkish",
    ru: "russian",
    ar: "arabic",
});
/** The primary subtag of a BCP-47 code, lowercased (`el-GR` → `el`). */
export function primarySubtagOf(language) {
    const [primary] = language.split("-");
    return (primary === undefined ? "" : primary).toLowerCase();
}
/** The configuration a passage in `language` is searched with: the closed table, `simple` for every other language. */
export function textSearchConfigOf(language) {
    const stemmed = STEMMED_BY_PRIMARY_SUBTAG[primarySubtagOf(language)];
    return stemmed === undefined ? "simple" : stemmed;
}
/**
 * How text is folded before it reaches the lexical search: `strip_marks` (NFD, marks stripped, NFC, lowercase without
 * locale, ς → σ) or `none` (NFC; the configuration's own stemmer folds).
 */
export const FOLD_POLICY = ["none", "strip_marks"];
/** `simple` and `wetalk_greek` → `strip_marks` (SPK-PG's finding for ϊ/ΐ); every other stemmed configuration → `none`. */
export function foldPolicyOf(config) {
    return config === "simple" || config === "wetalk_greek" ? "strip_marks" : "none";
}
//# sourceMappingURL=text-search-config.js.map